
import SAJM_GLOBALS from "../constants";
import GlobalUser from "../models/User";


export class UserController{

    /*constructor(){


    }*/

    /**********/
    /*LOG USER*/
    /**********/
    async logIn(username, password) {
        
        try {
            
            let params="apiFunctionName=getToken&apiFunctionParams={\"username\":\""+username+"\",\"password\":\""+password+"\"}";
            let url = SAJM_GLOBALS.API_HOST + "/?" + params;

            const response = await fetch(url);

                        
            if (!response.ok) {
                throw Error(response.statusText);
            }

            return await response.json();
        }
        catch (error) {
            console.log("UserController.logIn:"+error);
        }
        
    }

    /*
    
    Get List of all users

    */

    async getUsers() {

        let apiKey = GlobalUser.getApiKey();
        let token = GlobalUser.getToken();

        try {
            
            let params="apiFunctionName=getAccounts&apiKey="+apiKey+"&apiToken="+token;
            let url = SAJM_GLOBALS.API_HOST + "/?" + params;

            const response = await fetch(url);

                        
            if (!response.ok) {
                throw Error(response.statusText);
            }

            return await response.json();

        }
        catch (error) {
            console.log("UserController.getUser:"+error);
        }
    }


    /*
    
    Create new user

    */

    async createUser(name, firstname, mail, login, password, role){
        let apiKey = GlobalUser.getApiKey();
        let token = GlobalUser.getToken();
        
        try {
            let params="apiFunctionName=createAccount&apiKey="+apiKey+"&apiToken="+token;
            params += "&apiFunctionParams={\"login\":\""+login+"\",\"password\":\""+password+"\",\"name\":\""+name+"\",\"firstname\":\""+firstname+"\",\"mail\":\""+mail+"\",\"role\":\""+role+"\"}"

            let url = SAJM_GLOBALS.API_HOST + "/?" + params;
            const response = await fetch(url);
            
                        
            if (!response.ok) {
                throw Error(response.statusText);
            }

            return await response.json();

        }
        catch(error){
            console.log("UserController.createUser:"+error);
        }
    }
    
    /*
    
    Get user By ID

    */
    async getUserByID(id){

        let apiKey = GlobalUser.getApiKey();
        let token = GlobalUser.getToken();

        try {
            let params="apiFunctionName=getAccountByID&apiKey="+apiKey+"&apiToken="+token;
            params += "&apiFunctionParams={\"id\":\""+id+"\"}"

            let url = SAJM_GLOBALS.API_HOST + "/?" + params;
            const response = await fetch(url);
            
                        
            if (!response.ok) {
                throw Error(response.statusText);
            }

            return await response.json();

        }
        catch(error){
            console.log("UserController.getUserByID:"+error);
        }

    }

     /*
    
    Delete a user

    */
    async deleteUser(id){
        let apiKey = GlobalUser.getApiKey();
        let token = GlobalUser.getToken();
        
        try {
            let params="apiFunctionName=deleteAccount&apiKey="+apiKey+"&apiToken="+token;
            params += "&apiFunctionParams={\"userid\":\""+id+"\"}"

            let url = SAJM_GLOBALS.API_HOST + "/?" + params;
            const response = await fetch(url);
            
                        
            if (!response.ok) {
                throw Error(response.statusText);
            }

            return await response.json();

        }
        catch(error){
            console.log("UserController.deleteUser:"+error);
        }
   }


   /*
    
    Update user

    */

    async updateUser(id, name, firstname, mail, login, password, role){

        let apiKey = GlobalUser.getApiKey();
        let token = GlobalUser.getToken();

        try {
            let params="apiFunctionName=updateAccount&apiKey="+apiKey+"&apiToken="+token;
            params += "&apiFunctionParams={\"id\":\""+id+"\",\"name\":\""+name+"\",\"firstname\":\""+firstname+"\",\"mail\":\""+mail+"\",\"login\":\""+login+"\",\"password\":\""+password+"\",\"role\":\""+role+"\"}"

            let url = SAJM_GLOBALS.API_HOST + "/?" + params;
            const response = await fetch(url);
            
                        
            if (!response.ok) {
                throw Error(response.statusText);
            }

            return await response.json();

        }
        catch(error){
            console.log("UserController.updateUser:"+error);
        }
    }


    /**
     * Change Password
     */

    async changePassword (id, pwd){
        
        let apiKey = GlobalUser.getApiKey();
        let token = GlobalUser.getToken();

        try {
            let params="apiFunctionName=setAccountPassword&apiKey="+apiKey+"&apiToken="+token;
            params += "&apiFunctionParams={\"userid\":\""+id+"\",\"userpassword\":\""+pwd+"\"}"

            let url = SAJM_GLOBALS.API_HOST + "/?" + params;
            const response = await fetch(url);
            
                        
            if (!response.ok) {
                throw Error(response.statusText);
            }

            return await response.json();

        }
        catch(error){
            console.log("UserController.changePassword:"+error);
        }

    }

}
